<div class="relative" [class.open]="isOpen()" [class.light]="parentBackground() === 'dark'">
  <div
    class="flex items-center justify-between relative py-4 border-inherit sm:px-7 px-4 text-sm sm:text-base mt-2"
    [style.background]="parentBackground() === 'dark' ? 'dark' : 'var(--color-background-accordion-item-header)'"
    [ngClass]="{
      light_indicator: parentBackground() !== 'dark',
      'rounded-ss-lg rounded-se-lg': isOpen(),
      'rounded-lg': !isOpen(),
      'after:content-none': isOpen() && !isToggleEnabled(),
      'cursor-auto': !isToggleEnabled(),
      'text-[--basic-white]': parentBackground() === 'dark',
      'font-bold': parentBackground() === 'dark',
    }"
    (click)="isToggleEnabled() ? toggle() : null"
    (keydown)="onKeyDown($event)"
    role="button"
    (keydown.enter)="toggle()"
    [id]="'expansion-panel-header-' + index()"
    tabindex="0"
    [attr.aria-controls]="'accordion-child-' + index()"
    [attr.aria-expanded]="isOpen()"
    aria-disabled="false"
  >
    <ng-content select="[header]" />
    <span
      class="border-solid border-r-2 border-b-2 inline-block align-middle p-1 transition-transform will-change-transform"
      [ngClass]="{
        'border-white': parentBackground() === 'dark',
        'border-[--color-text-secondary]': parentBackground() !== 'dark',
        hidden: isOpen() && !isToggleEnabled(),
        'rotate-[-135deg]': isOpen(),
        'rotate-45': !isOpen(),
      }"
    ></span>
  </div>

  @if (isOpen()) {
    <div
      class="py-4 sm:px-7 px-4 overflow-hidden shadow-[0_2px_8px_rgba(0,0,0,0.1)] rounded-ee-lg rounded-es-lg border-inherit"
      [ngClass]="{ 'shadow-none	': parentBackground() === 'dark' }"
      [style.background]="parentBackground() === 'dark' ? 'dark' : 'white'"
      [@accordionBody]
      [attr.aria-labelledby]="'expansion-panel-header-' + index()"
      [id]="'accordion-child-' + index()"
    >
      <ng-content />
    </div>
  }
</div>
